export const WAITLIST_STATUSES = ['joined', 'invite_pending', 'invited', 'registered', 'rejected']
export const INVITE_STATES = ['none', 'pending', 'sent', 'failed', 'expired', 'claimed', 'closed']

/**
 * @param {{ id: string, status: string, invite_state: string }} entry
 */
export function waitlistRowActions(entry) {
  switch (entry.status) {
    case 'joined':
      return ['view', 'invite', 'reject', 'note']
    case 'invite_pending':
      return ['view', 'note']
    case 'invited':
      return invitedRowActions(entry)
    case 'registered':
      return ['view', 'note']
    case 'rejected':
      return ['view', 'note']
    default:
      throw new Error(`Unhandled status: ${entry.status}, id: ${entry.id}`)
  }
}

/**
 * @param {{ id: string, invite_state: string }} entry
 */
function invitedRowActions(entry) {
  switch (entry.invite_state) {
    case 'sent':
    case 'expired':
      return ['view', 'resend', 'reject', 'note']
    case 'claimed':
      return ['view', 'note']
    case 'closed':
      return ['view', 'note']
    case 'pending':
      return ['view', 'note']
    case 'none':
    case 'failed':
      return ['view', 'resend', 'reject', 'note']
    default:
      throw new Error(`Unhandled invite_state: ${entry.invite_state}, id: ${entry.id}`)
  }
}

/**
 * @param {{ id: string, status: string, invite_state: string, marketing_consent_accepted_at: string|null }} entry
 */
export function waitlistDetailActions(entry) {
  const actions = waitlistRowActions(entry).filter((action) => action !== 'view')
  if (entry.marketing_consent_accepted_at === null) {
    return actions.filter((action) => action !== 'invite' && action !== 'resend')
  }
  return actions
}
